<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '维修保养'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <section slot="car" slot-scope="prop">
          <ChooseCar :isRadio="true" v-model="prop.form.car" @change="handleCarChange" />
        </section>
        <!-- 维修站点 -->
        <section slot="site" slot-scope="prop">
          <ChooseSite
            :isRadio="true"
            v-model="prop.form.site"
            @change="handleSiteChange"
            :otherSearchData="{
              serviceName: serviceInfo.serviceName,
              mobilePhone: serviceInfo.servicePhone,
            }"
            :fnRadioDisabled="
              (item) => {
                if(serviceInfo.serviceName && serviceInfo.servicePhone){
                  let disabled = true;
                  if ((item.mobilePhone === serviceInfo.servicePhone) && (item.serviceName === serviceInfo.serviceName)) {
                    disabled = false;
                  }
                  return disabled;
                }else{
                  return false;
                }
              }
            "
          />
        </section>
        <!-- 维修站点 end -->
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
import ChooseSite from 'components/choose/site';
import {
  getEnumList,
  // getDepartmentAllList,
} from 'api';
export default {
  components: {
    ChooseCar,
    ChooseSite,
  },
  props: {
    serviceInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        applyTypeOptions: [], // 费用类型
        form: [
          {
            label: '费用类型',
            value: 'applyType',
            type: 'select',
          },
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '牌照类型',
            value: 'licenceTypeName',
            type: 'input',
            placeholder: '请输入牌照类型',
            disabled: true,
          },
          {
            label: '维修站点',
            value: 'site',
            default: {},
            slot: true,
          },
          {
            label: '服务商',
            value: 'serviceName',
            type: 'input',
            disabled: true,
          },
          {
            label: '维修日期',
            value: 'feeAscriptionDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '维修费用',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入维修费用',
          },
          {
            label: '维修内容',
            value: 'repairReson',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },

          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: { // 表单验证规则
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          site: [ // 维修站点
            { required: true, message: '请选择维修站点', trigger: 'blur' },
          ],
          serviceName: [ // 服务商
            { required: true, message: '请选择服务商', trigger: 'blur' },
          ],
          feeAscriptionDate: [ // 维修日期
            { required: true, message: '请选择维修日期', trigger: 'blur' },
          ],
          payAmt: [ // 申请金额
            { required: true, message: '请输入申请金额', trigger: 'blur' },
          ],
          repairReson: [ // 维修内容
            { required: true, message: '请输入费用说明', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      await this.getList();
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          // 车牌号码
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          item.site = {
            serviceName: item.serviceName,
            serviceUserId: item.serviceId,
            productName: item.productName,
            productId: item.productId,
          };
          // item.repairReson = item.payRemark;
          item.applyType = String(item.applyType);
          this.$refs.customForm.setVal(item);
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    async handleCarChange () {
      const car = this.$refs.customForm.getVal('car');
      this.$refs.customForm.setVal('licenceTypeName', car.licenceTypeName);
    },

    async handleSiteChange () {
      const site = this.$refs.customForm.getVal('site');
      this.$refs.customForm.setVal('serviceName', site.serviceName);
      await this.$emit('getOtherFormVal', {
        from: 'detailForm',
        tar: 'customForm',
      });
    },

    async getList () {
      // this.baseForm.orgIdOptions = await getDepartmentAllList();
      const enumsList = await getEnumList({
        codeType: 'REPAIR_APPLY_TYPE,REPAIR_APPLY_STATE',
      });
      this.formData.applyTypeOptions = enumsList[0]; // 费用类型
      // this.baseForm.stateOptions = enumsList[1]; // 维保状态
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车牌号码
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;

      form.serviceName = form.site.serviceName;
      form.serviceId = form.site.serviceUserId;
      form.productName = form.site.productName;
      form.productId = form.site.productId;

      delete form.site;
      delete form.car;
      // 维修日期
      form.feeAscriptionDate = this.formatDate(form.feeAscriptionDate, 1);
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
